import { useEffect } from 'react';
import VanillaTilt from 'vanilla-tilt';
import styles from './Personal.module.css';

function Personal() {
    const preventDefault = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        const tiltElements = document.querySelectorAll(".imd-3d");
        tiltElements.forEach(element => {
        VanillaTilt.init(element, {
            max: 25,
            speed: 400,
            glare: true,
            "max-glare": 0.5,
        });
        });
    }, []);

  return (
    <div>
      <h1 className="text-shadow-active">Personal Works</h1>

      <h2  className='mb-3 mt-3 text-shadow-active'>Mobile</h2>

      {/* WriteyKids section*/}
      <div className={ styles.personalSection}>
        <div className={ styles.mobileImgSection }>
            <div className="imd-3d">
                <img className={ styles.imgLSMobile + " me-2" } src="/assets/images/writeykids-reactnative/promotion1.png" alt="wtk1" />
            </div>
        </div>
        <div className={ styles.personalDescSection }>
          <h3>WriteyKids(iOS)</h3>
          <span>A simple way to teach your kids to write!</span>
          <p>
            <span>STATUS:</span> 
            <a className="not-live" href="npm r" target="_blank" rel="noreferrer">
                <strong> APPSTORE [Coming soon...]</strong>
            </a>

            <a className="not-live" href="" target="_blank" rel="noreferrer">
                <strong> GOOGLE PLAY STORE [Coming soon...]</strong>
            </a>
            <i> ← click to view</i>
          </p>

          <p>Stack:
              <ul>
                <li>Frontend: React Native</li>
                <li>Database: Async Storage, Expo SecureStore</li>
              </ul>
          </p>
        </div>
      </div>

      {/* KeepKit section*/}
      <div className={ styles.personalSection}>
        <div className={ styles.mobileImgSection }>
            <div className="imd-3d">
                <img className={ styles.imgMobile + " me-2" } src="/assets/images/keepkit-ios/screen1.png" alt="kkt1" />
                <img className={ styles.imgMobile } src="/assets/images/keepkit-ios/screen2.png" alt="kkt2" />
            </div>
        </div>
        <div className={ styles.personalDescSection }>
          <h3>KeepKit(iOS)</h3>
          <span>Keep your logins safe!</span>
          <p>
            <span>STATUS:</span> 
            <a className="live" href="https://apps.apple.com/ph/app/keepkit/id6776478717" target="_blank" rel="noreferrer">
                <strong> APPSTORE</strong>
            </a>
            <i> ← click to view</i>
          </p>

          <p>Stack:
              <ul>
                <li>Frontend: iOS(SwiftUI)</li>
                <li>Database: SwiftData</li>
              </ul>
          </p>
        </div>
      </div>

      {/* Rick&Morty section*/}
      <div className={ styles.personalSection}>
        <div className={ styles.mobileImgSection }>
            <div className="imd-3d">
                <img className={ styles.imgMobile + " me-2" } src="/assets/images/rnm-ios/screen1.jpg" alt="rnm1" />
                <img className={ styles.imgMobile } src="/assets/images/rnm-ios/screen2.jpg" alt="rnm2" />
            </div>
        </div>
        <div className={ styles.personalDescSection }>
          <h3>Rick & Morty(iOS)</h3>
          <span>Have you watch Rick & Morty? Here's the character list, you can even add favorites!</span>
          <p>
            <span>STATUS:</span> 
            <a className="not-live" href="/" onClick={preventDefault}>
                <strong> OFFLINE</strong>
            </a>
          </p>

          <p>Stack:
              <ul>
                <li>Frontend: iOS(SwiftUI)</li>
              </ul>
          </p>
        </div>
      </div>

      {/* CALCULATOR section*/}
      <div className={ styles.personalSection}>
        <div className={ styles.mobileImgSection }>
            <div className="imd-3d">
                <img className={ styles.imgMobile + " me-2" } src="/assets/images/calculator-flutter/screen1.jpg" alt="calculator1" />
                <img className={ styles.imgMobile } src="/assets/images/calculator-flutter/screen2.jpg" alt="calculator2" />
            </div>
        </div>
        <div className={ styles.personalDescSection }>
          <h3>CALCULATOR(Flutter)</h3>
          <span>My own calculator, I guess??</span>
          <p>
            <span>STATUS:</span> 
            <a className="not-live" href="/" onClick={preventDefault}>
                <strong> OFFLINE</strong>
            </a>
          </p>

          <p>Stack:
              <ul>
                <li>Frontend: Flutter(Dart), Android, iOS</li>
              </ul>
          </p>
        </div>
      </div>

      {/* BREAKFAST section*/}
      <div className={ styles.personalSection}>
        <div className={ styles.mobileImgSection }>
            <div className="imd-3d">
                <img className={ styles.imgMobile + " me-2" } src="/assets/images/bfast-menu-flutter/screen1.png" alt="bfast1"/>
                <img className={ styles.imgMobile } src="/assets/images/bfast-menu-flutter/screen2.png" alt="bfast2"/>
            </div>
        </div>
        <div className={ styles.personalDescSection }>
          <h3>Breakfast Menu(Flutter)</h3>
          <span>Breakfast list and it's recipes. For you and your tummy</span>
          <p>
            <span>STATUS:</span> 
            <a className="not-live" href="/" onClick={preventDefault}>
                <strong> OFFLINE</strong>
            </a>
          </p>

          <p>Stack:
              <ul>
                <li>Frontend: Flutter(Dart), Android, iOS</li>
              </ul>
          </p>
        </div>
      </div>
    </div>
    );
}

export default Personal;